import React, { Link } from "react"
import { LayoutFeatureCarousel } from "trimble-terra"
import renderPaddingOrFullBleed from "../renderPaddingOrFullBleed"
import { formatCommonComponentFields } from "./formatLayoutFunctions"
import { formatThemePreset } from "../formatTheme"
import formatPageLinks from "../formatPageLinks"
import { formatFocusedImage } from "../formatBaseMolecules"

const FormatAndRenderLayoutFeatureCarousel = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
}) => {
  const formattedComponentData = formatCommonComponentFields(
    data,
    locale,
    siteIdentifier,
    homepageSlug,
    currentSpaceId
  )

  let featuredCarouselBlockQuote = null
  if (
    formattedComponentData?.featureCarouselQuote &&
    formattedComponentData?.featureCarouselQuote?.quote
  ) {
    featuredCarouselBlockQuote = {
      ...formattedComponentData?.featureCarouselQuote,
      attributionName: formattedComponentData?.featureCarouselQuote?.author,
      attributionQualification:
        formattedComponentData?.featureCarouselQuote?.qualification,
      quote: formattedComponentData?.featureCarouselQuote?.quote?.quote,
      button: {
        ...formattedComponentData?.featureCarouselQuote?.button[0],
        label:
          formattedComponentData?.featureCarouselQuote?.button[0]?.linkText,
        destination:
          formattedComponentData?.featureCarouselQuote?.button[0]?.LinkUrl,
      },
    }
  }

  const formattedButtons = formattedComponentData?.buttons?.map(button => {
    const formattedButton = formatPageLinks(
      button,
      locale,
      button?.dynamicPageReference?.__typename,
      homepageSlug,
      currentSpaceId,
      siteIdentifier
    )
    return {
      ...formattedButton,
      label: formattedButton?.text,
      destination: formattedButton?.linkUrl || formattedButton?.destination,
      primary: button.isPrimary ? true : false,
      size: "large",
    }
  })

  const formattedLayoutFeatureCarouselData = {
    ...formattedComponentData,
    featureItems: formattedComponentData?.featureCarouselItems?.map(item => {
      const linkUrl = item?.destination?.[0]?.linkUrl || item?.destination?.[0]?.dynamicPageReference?.url
      const isAnchorLink = linkUrl?.startsWith?.('#')
      
      const formattedFeatureItemButton = {
        text: item?.destination?.[0]?.linkText || item?.destination?.[0]?.text,
        url: linkUrl,
        __typename: item?.destination?.[0]?.__typename,
      }

      // If it's an anchor link, format to keep it on the current page
      const ctaLink = isAnchorLink 
        ? {
            text: formattedFeatureItemButton.text,
            url: linkUrl,
            destination: linkUrl,
            label: formattedFeatureItemButton.text,
            Link: null,
          }
        : formatPageLinks(
            formattedFeatureItemButton,
            locale,
            item?.destination?.[0]?.__typename,
            homepageSlug,
            currentSpaceId,
            siteIdentifier
          )

      return {
        ...item,
        description: item?.shortDescription?.shortDescription,
        image: {
          ...formatFocusedImage(item.featureCarouselImage),
          alt:
            item?.featureCarouselImage?.altText ||
            item?.featureCarouselImage?.title,
          src: item?.featureCarouselImage?.image?.file?.url,
        },
        ctaLink,
      }
    }),
    featureBlockQuote: featuredCarouselBlockQuote,
    buttons: formattedButtons,
  }

  return (
    <LayoutFeatureCarousel
      {...formattedLayoutFeatureCarouselData}
      isWrapped={true}
    />
  )
}

export default FormatAndRenderLayoutFeatureCarousel